import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "27",
  height: "27",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "13.5",
      cy: "13.5",
      r: "13",
      stroke: "#143A5F"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#143A5F",
      d: "M18.803 8.197 8.196 18.803M18.803 18.803 8.196 8.197"
    }, null, -1)
  ])))
}
export default { render: render }